<template>
  <footer>
    <div class="footer">
      <img src="../assets/logo2.png" alt="股励" class="logo" />
      <div class="contract">
        <div class="contract-item">
          <img src="../assets/kefu.png" class="contract-img" alt="联系客服  " />
          <p>联系客服</p>
        </div>
        <div class="contract-item big">
          <p style="text-align: center;">与股励合作</p>
          <p>hi@51guli.com</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="postcss">
footer {
  width: 100%;
  height: 130px;
  background-color: #ffffff;
}

.footer {
  width: 1200px;
  margin: auto;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.contract {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.contract-item {
  text-align: center;
  margin: 0 27px;
}

.contract-img {
  width: 80px;
  height: 80px;
}

.contract-item p {
  margin-top: 8px;
}

.big {
  font-size: 24px;
  text-align: left;
  height: 100%;
}

@media (max-width: 1200px) {
  footer {
    height: auto;
    background-color: #ffffff;
  }
  .footer {
    width: 100%;
    display: block;
  }
  .footer .logo {
    display: none;
  }
  .contract {
    flex-direction: row;
    justify-content: center;
  }
  .contract-item {
    margin: 10px;
  }
  .big {
    font-size: 18px;
  }
}

@media (max-width: 580px) {
  footer {
    height: auto;
    background-color: #ffffff;
  }
  .footer {
    width: 100%;
    display: block;
  }
  .footer .logo {
    display: none;
  }
  .contract {
    flex-direction: row;
    justify-content: center;
  }
  .contract-item {
    margin: 10px;
  }
  .big {
    font-size: 18px;
  }
}
</style>